import React, { useEffect, useState } from "react";
import Tooltip from '@mui/material/Tooltip';
import {
  TextField,
  Table,
  TableBody,
  Select,
  Paper,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  IconButton,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Snackbar,
  Alert,
  Autocomplete,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  Pagination,
  TableCell,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";
import { parseDate, getLocalTimeZone } from '@internationalized/date';
import DatePickerField from "../../../common/DatePickerDashboard";
import {
  saveTaskAction,
  searchTaskAction,
  updateTaskAction,
  deleteTaskActionById,
  getTaskByPolicyAction,
  searchUserOnTaskAction,
  getTypeOfTaskOpenListAction,
} from "../../../redux/actions/taskActions";
import { useDispatch, useSelector, shallowEqual  } from "react-redux";
import {
  getCustomerDataAction,
  getTaskListDataAction,
} from "../../../redux/actions/customerSearchAction";
import { CustomTableCell } from '../../../common/CustomTableCell';
import NoDataFound from "../../../common/NoDataFound";

const poppinsFont = {
  fontFamily: '"Poppins", sans-serif',
};

const TaskComponent = ({
  policyId,
  getPolicyNumber,
  showOnlyAddTask,
  customerId,
  selectedOption,
  selectedPolicyId,
  clientCustomerIdTask
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [tableSaveLoader, setTableSaveLoader] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [selectPolicyId, setSelectPolicyId] = useState(
    selectedPolicyId ? Number(selectedPolicyId) : ""
  );
  const [taskFormType, setTaskFormType] = useState("Policies");

  const dispatch = useDispatch();
  const taskData = useSelector((state) => state.task.allTask);
  const customer_id = useSelector(
    (state) => state?.customerDetails?.client_customer_id || null
  );
  const customer_data = useSelector(
    (state) => state?.customerDetails?.selected_customer_details || null
  );
  const searchtaskData = useSelector((state) => state.task.searchTask);
const searchUsers = useSelector(
  (state) => state.task.searchUser?.content,
  shallowEqual
) || [];

  const data =
    searchtaskData && searchtaskData.length > 0
      ? searchtaskData
      : taskData.content || [];
  const finalData = data || [];

  const typeOfTaskOpens = useSelector((state) => state?.task?.type_task_list || []);
  const [fromDate, setFromDate] = useState(dayjs().startOf('month'));
  const [toDate, setToDate] = useState(dayjs());


  const getToday = () => {
    const today = new Date();
    return parseDate(
      `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
    );
  };

  const getFirstOfMonth = () => {
    const today = new Date();
    return parseDate(
      `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-01`
    );
  };

  const formatForForm = (date) => {
    const d = date.toDate(getLocalTimeZone());
    return `${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}-${d.getFullYear()}`;
  };

  const initialFormData = {
    fromDate: formatForForm(getFirstOfMonth()),
    toDate: formatForForm(getToday()),
    dueDate: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [fieldErrors, setFieldErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});

  const [formValues, setFormValues] = useState({
    customer: null,
    createdDate: null,
    closedDate: null,
    closedBy: "",
    taskTo: "",
    dueDate: null,
    status: "Open",
    priority: "",
    taskType: "",
    assignedToName: null,
    assignedTo: "",
    taskDescription: "",
  });

  const [searchValues, setSearchValues] = useState({
    subject: null,
    status: "",
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [editingTask, setEditingTask] = useState(null);
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [userSearchTimeout, setUserSearchTimeout] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);
  const [isCustomerSelected, setIsCustomerSelected] = useState(false);
  const [isAssignedToSelected, setIsAssignedToSelected] = useState(false);
  const [assigned, setAssigned] = useState(null);

  // useEffect(() => {
  //   fetchTasks();
  //   const customerIdToFetch = formValues.customer?.id || customerId || customer_id;
  //   if (customerIdToFetch) {
  //     dispatch(getCustomerDataAction(customerIdToFetch));
  //   }
  // }, [dispatch, page, rowsPerPage, selectedPolicyId, customerId]);

  useEffect(() => {
    if (open) {
      dispatch(getTypeOfTaskOpenListAction());
    }
  }, [dispatch, open]);

  const handleDateChange = (fieldName, value) => {
    setFormData((prev) => ({ ...prev, [fieldName]: value }));

    if (fieldName === "dueDate") {
      setFormValues((prev) => ({
        ...prev,
        dueDate: value ? dayjs(value, "MM-DD-YYYY") : null,
      }));


      if (value) {
        setErrors((prev) => ({ ...prev, dueDate: undefined }));
        setFieldErrors((prev) => ({ ...prev, dueDate: undefined }));
      }
    }
  };

  const handleBlur = (fieldName, errorMsg) => {
    setTouchedFields((prev) => ({ ...prev, [fieldName]: true }));
    setFieldErrors((prev) => ({ ...prev, [fieldName]: errorMsg }));
  };

const handleTaskFormTypeChange = (event) => {
  const newType = event.target.value;
  setTaskFormType(newType);

  if (newType === "Customer") {
    setSelectPolicyId("");
    setIsCustomerSelected(false);
  } else {
    setFormValues((prev) => ({
      ...prev,
      customer: null,
    }));
    setIsCustomerSelected(true);
  }
};

  const fetchTasks = () => {
    setLoading(true);

    if (isFiltered) {
      const { subject, status } = searchValues;
      const searchParams = {
        fromDate: dayjs(formData.fromDate).format('YYYY-MM-DD') || "",
        toDate: dayjs(formData.toDate).format('YYYY-MM-DD') || "",
        status: status || null,
        search: subject || null,
        ...(selectedOption === "All" && customerId && { clientCustomerId: customerId }),
      };

      dispatch(
        searchTaskAction(
          searchParams,
          selectedOption === "Policies" ? selectPolicyId : null,
          page,
          rowsPerPage,
          () => setLoading(false)
        )
      );
    } else {
      if (selectedOption === "All") {
        const finalId = customerId ? customerId : customer_id;
        dispatch(
          getTaskListDataAction(finalId, page, rowsPerPage, () => setLoading(false))
        );
      } else if (selectedOption === "Policies" && selectedPolicyId) {
        dispatch(
          getTaskByPolicyAction(Number(selectedPolicyId), page, rowsPerPage, () =>
            setLoading(false)
          )
        );
      } else if (getPolicyNumber) {
        dispatch(
          getTaskListDataAction(customer_id, page, rowsPerPage, () => setLoading(false))
        );
      }
    }
  };

  const handleEditClick = (row) => {
    setLoading(false);
    setEditingTask(row);
    const hasPolicy = row.policyId || row.policyNumber;
    setTaskFormType(hasPolicy ? "Policies" : "Customer");

    const customerForTask = row.clientCustomerId
      ? customers.find((c) => c.id === row.clientCustomerId) || {
          id: row.clientCustomerId,
          firstName: row.customerFirstName || "",
          lastName: row.customerLastName || "",
        }
      : null;

    const isUserMissing = row.assignedTo &&
      !searchUsers.some((user) => user.id === row.assignedTo);
    if (isUserMissing) {
      dispatch(searchUserOnTaskAction(row.assignedToName || ""));
    }

    setFormValues({
      id: row.id,
      assignedTo: row.assignedTo,
      assignedToName: row.assignedToName,
      taskTo: row.taskTo,
      dueDate: row.dueDate ? dayjs(row.dueDate) : null,
      subject: row.subject,
      status: row.status || "Open",
      closedDate: row.closedDate,
      closedBy: row.closedBy,
      priority: row.priority,
      taskType: row.taskType,
      taskDescription: row.taskDescription,
      customer: customerForTask,
    });

    setFormData((prev) => ({
      ...prev,
      dueDate: row.dueDate ? dayjs(row.dueDate).format("MM-DD-YYYY") : "",
    }));

    setAssigned(row.assignedToName);
    setSelectPolicyId(hasPolicy ? Number(row.policyId) : "");

    setIsCustomerSelected(true);
    setIsAssignedToSelected(!!row.assignedToName);
    setOpen(true);

    if (row.clientCustomerId) {
      dispatch(getCustomerDataAction(row.clientCustomerId));
    }
  };

  const handleDeleteClick = (taskId) => {
    setSelectedTaskId(taskId);
    setOpenDialog(true);
  };

  const handleConfirmDelete = () => {
    setOpenDialog(false);
    setShowLoader(true);

    if (selectedTaskId !== null) {
      dispatch(deleteTaskActionById(selectedTaskId))
        .then(() => {
          fetchTasks();
          setSnackbar({
            open: true,
            message: "Task deleted successfully",
            severity: "success",
          });
        })
        .catch(() => {
          setSnackbar({
            open: true,
            message: "Failed to delete task",
            severity: "error",
          });
        })
        .finally(() => {
          setShowLoader(false);
          setSelectedTaskId(null);
        });
    }
  };

  const handlePolicyChange = (event) => {
    const value = event.target.value;
    setSelectPolicyId(value ? Number(value) : "");

    if (value) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.selectPolicyId;
        return newErrors;
      });
    }
  };

  const handleCancelDelete = () => {
    setOpenDialog(false);
    setSelectedTaskId(null);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const [errors, setErrors] = useState({});

  const handleUserInputChange = (event, newInputValue) => {
    setUserSearchTerm(newInputValue);

    if (userSearchTimeout) {
      clearTimeout(userSearchTimeout);
    }

    const timeoutId = setTimeout(() => {
      if (newInputValue?.length >= 2) {
        dispatch(searchUserOnTaskAction(newInputValue));
      }
    }, 300);

    setUserSearchTimeout(timeoutId);
  };

  const resetFormValues = () => {
    setFormValues({
      customer: null,
      createdDate: null,
      closedDate: null,
      closedBy: "",
      taskTo: "",
      dueDate: null,
      status: "Open",
      priority: "",
      taskType: "",
      assignedToName: null,
      assignedTo: "",
      taskDescription: "",
    });
    setFormData((prev) => ({
      ...prev,
      dueDate: "",
    }));
    setIsAssignedToSelected(false);
  };

const handleSubmit = () => {
    let newErrors = {};

    if (taskFormType === "Policies" && !selectPolicyId) {
      newErrors.selectPolicyId = "Select Policy is required";
    }

    if (!formValues.assignedToName || !formValues.assignedTo) {
      newErrors.assignedToName = "Assigned To is required";
    }

    if (!formValues.dueDate || !formData.dueDate) {
      newErrors.dueDate = "Due Date is required";
      setFieldErrors((prev) => ({ ...prev, dueDate: "Due Date is required" }));
    }

    if (!formValues.status) newErrors.status = "Status is required";
    if (!formValues.priority) newErrors.priority = "Task Priority is required";
    if (!formValues.taskType) newErrors.taskType = "Type Of Task is required";

    if (!formValues.taskDescription?.trim()) {
      newErrors.taskDescription = "Task Description is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setSnackbar({
        open: true,
        message: "Please fill in all required fields",
        severity: "error",
      });
      return;
    }

    const formattedFormValues = {
      ...formValues,
      dueDate: formValues.dueDate
        ? dayjs(formValues.dueDate).format("YYYY-MM-DD")
        : null,
    };

    setTableSaveLoader(true);

    const onSuccess = () => {
      setOpen(false);
      setTableSaveLoader(false);

      if (selectedOption === "Policies" && selectPolicyId) {
        dispatch(
          getTaskByPolicyAction(selectPolicyId, page, rowsPerPage, () =>
            setLoading(false)
          )
        );
      } else {
        const finalId = customerId ? customerId : customer_id;
        dispatch(
          getTaskListDataAction(finalId, page, rowsPerPage, () => setLoading(false))
        );
      }

      setSnackbar({
        open: true,
        message: editingTask ? "Task updated successfully" : "Task added successfully",
        severity: "success",
      });

      resetFormValues();
    };

    const onError = (errorMessage) => {
      setTableSaveLoader(false);

      setSnackbar({
        open: true,
        message: errorMessage || "Failed to save task. Please try again.",
        severity: "error",
      });
    };

    // Check if task type has been switched during edit
    const hasTaskTypeSwitched = editingTask && (
      (taskFormType === "Policies" && !editingTask.policyId) ||
      (taskFormType === "Customer" && editingTask.policyId)
    );

    const cleanFormValues = { ...formattedFormValues };

    // Remove all association fields first
    delete cleanFormValues.policyId;
    delete cleanFormValues.clientCustomerId;
    delete cleanFormValues.id;
    
    let finalValue;

    if (taskFormType === "Customer") {
      // Get clientCustomerId from multiple sources in priority order
      const clientCustomerId = 
        clientCustomerIdTask || 
        formValues.customer?.id || 
        editingTask?.clientCustomerId ||
        customerId ||
        customer_id;
        
      finalValue = {
        ...cleanFormValues,
        clientCustomerId: clientCustomerId
      };
    } else if (taskFormType === "Policies") {
      finalValue = {
        ...cleanFormValues,
        policyId: selectPolicyId
      };
    }

    if (editingTask) {
      if (hasTaskTypeSwitched) {
        // Delete old task and create new one with clean data
        dispatch(deleteTaskActionById(editingTask.id))
          .then(() => {
            // Add delay to ensure deletion is complete
            setTimeout(() => {
              dispatch(saveTaskAction(finalValue, onSuccess, onError));
            }, 500);
          })
          .catch(() => {
            setTableSaveLoader(false);
            setSnackbar({
              open: true,
              message: "Failed to switch task type. Please try again.",
              severity: "error",
            });
          });
      } else {
        // Normal update - add id back for update
        dispatch(
          updateTaskAction(
            { id: editingTask.id, ...finalValue },
            onSuccess,
            onError
          )
        );
      }
    } else {
      dispatch(saveTaskAction(finalValue, onSuccess, onError));
    }
    setOpen(false);
  };

  const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    
  }));

const handleClickOpen = () => {
  setEditingTask(null);

  resetFormValues();
  setErrors({});
  setFieldErrors({});
  setSelectPolicyId("");
  setTaskFormType("Policies");

  // If a customer is already selected, pre-fill it
  if (customer_data) {
    const customerObj = {
      id: customer_data.id,
      firstName: customer_data.firstName,
      lastName: customer_data.lastName,
    };

    const matchedPolicy = policies.find((p) => p.customerId === customer_data.id);

    setFormValues((prev) => ({
      ...prev,
      customer: customerObj,
    }));

    setSelectPolicyId(matchedPolicy?.id ? Number(matchedPolicy.id) : "");
    setIsCustomerSelected(true);
    setIsAssignedToSelected(false);
  }

  setOpen(true);
};


  const handleClose = () => {
    setOpen(false);
    setEditingTask(null);
    setIsCustomerSelected(false);
    setIsAssignedToSelected(false);
    setErrors({});
    setFieldErrors({});
    setSelectPolicyId("");
    setFormValues({
      policyId: policyId ? Number(policyId) : null,
      assignedToName: null,
      assignedTo: "",
      customer: null,
      createdDate: null,
      closedDate: null,
      closedBy: "",
      taskTo: "",
      dueDate: null,
      status: "Open",
      priority: "",
      taskType: "",
      taskDescription: "",
    });
    setFormData((prev) => ({
      ...prev,
      dueDate: "",
    }));
    setTaskFormType("Policies");
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const resetSearch = () => {
    setFromDate(dayjs().startOf('month'));
    setToDate(dayjs());
    setFormData({
      fromDate: formatForForm(getFirstOfMonth()),
      toDate: formatForForm(getToday()),
      dueDate: "",
    });
    setSearchValues({
      subject: "",
      status: "",
    });
    setFieldErrors({});
    setTouchedFields({});

    setIsSearching(false);
    setIsFiltered(false);

    if (selectedOption === "Policies" && selectedPolicyId) {
      dispatch(
        getTaskByPolicyAction(Number(selectedPolicyId), page, rowsPerPage, () =>
          setLoading(false)
        )
      );
    } else {
      dispatch(getTaskListDataAction(customerId, page, rowsPerPage, () => setLoading(false)));
    }
  };

  const handleSearch = () => {
    const { subject, status } = searchValues;
    const hasSearchParams = formData.fromDate || formData.toDate || subject || status;

    if (!hasSearchParams) {
      setSnackbar({
        open: true,
        message: "Please provide at least one search parameter",
        severity: "error",
      });
      return;
    }

    setShowLoader(true);
    setIsSearching(true);
    setIsFiltered(true);
    setPage(0);

    const searchParams = {
      fromDate: dayjs(formData.fromDate).format('YYYY-MM-DD') || "",
      toDate: dayjs(formData.toDate).format('YYYY-MM-DD') || "",
      status: status || null,
      search: subject || null,
      ...(selectedOption === "All" && customerId && { clientCustomerId: customerId }),
    };

    dispatch(
      searchTaskAction(
        searchParams,
        selectedOption === "Policies" ? selectPolicyId : null,
        0,
        rowsPerPage,
        (response, error) => {
          setShowLoader(false);
          setSnackbar({
            open: true,
            message: error
              ? `Error searching tasks: ${error}`
              : "Search completed successfully",
            severity: error ? "error" : "success",
          });
        }
      )
    );
  };

const customers = useSelector(
  (state) =>
    state?.globalSearchReducer?.customer_search_task_list?.content ?? [],
  shallowEqual
);
  const policies = useSelector(
    (state) => state?.globalSearchReducer?.customer_data?.content || []
  );

  const allFieldsEnabled =
    taskFormType === "Policies"
      ? selectPolicyId && selectPolicyId !== ""
      : isAssignedToSelected || formValues.dueDate;

  const getShortDescription = (text, wordLimit = 4) => {
    if (!text) return "";
    const words = text.trim().split(" ");
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ") + "...";
  };
  useEffect(() => {
    if (taskFormType === "Policies" && policies.length > 0 && selectPolicyId === "") {
      setSelectPolicyId(Number(policies[0].id));
    }
  }, [policies, taskFormType, selectPolicyId]);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: "0 20px",
        gap: 2,
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            gap:1,
            width: "100%",
            mb: 2,
            "& > *:not(:last-child)": {
              marginRight: "0px",
            },
          }}
        >
          {!showOnlyAddTask && (
            <>
              <Box
                sx={{
                  width: "240px",
                }}
              >
                <Typography variant="body1" sx={{ mb: 0.5, ...poppinsFont }}>
                  From Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePickerField
                    fieldName="fromDate"
                    formData={formData}
                    handleDateChange={handleDateChange}
                    handleBlur={handleBlur}
                    touchedFields={touchedFields}
                    fieldErrors={fieldErrors}
                  />
                </LocalizationProvider>
              </Box>

              <Box
                sx={{
                  width: "240px",
                }}
              >
                <Typography variant="body1" sx={{ mb: 0.5, ...poppinsFont }}>
                  To Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePickerField
                    fieldName="toDate"
                    formData={formData}
                    handleDateChange={handleDateChange}
                    handleBlur={handleBlur}
                    touchedFields={touchedFields}
                    fieldErrors={fieldErrors}
                  />
                </LocalizationProvider>
              </Box>

              <Box
                sx={{
                  width: "150px",
                }}
              >
                <Typography variant="body1" sx={{ mb: 0.5, ...poppinsFont }}>
                  Subject
                </Typography>
                <TextField
                  sx={{
                    width: "150px",
                    "& .MuiInputBase-root": {
                      height: "56px",
                      display: "flex",
                      alignItems: "center",
                    },
                    "& input": { height: "100%" },
                  }}
                  name="subject"
                  value={searchValues.subject || ""}
                  onChange={handleSearchChange}
                  size="small"
                />
              </Box>

              <Box
                sx={{
                  width: "100px",
                }}
              >
                <Typography variant="body1" sx={{ mb: 0.5, ...poppinsFont }}>
                  Status
                </Typography>
                <Select
                  name="status"
                  value={searchValues.status}
                  onChange={handleSearchChange}
                  native
                  inputProps={{
                    name: 'status',
                    id: 'status-native',
                  }}
                  size="small"
                  sx={{
                    height: "56px",
                    "& .MuiInputBase-root": {
                      height: "56px",
                      display: "flex",
                      alignItems: "center",
                    },
                    fontFamily: '"Poppins", sans-serif',
                  }}
                >
                  <option value="">All</option>
                  <option value="Open">Open</option>
                  <option value="Close">Close</option>
                </Select>
              </Box>

              <Box>
                <Button
                  onClick={handleSearch}
                  variant="outlined"
                  sx={{marginTop: "30px",}}
                  disabled={!formData.fromDate || !formData.toDate}
                >
                  Search
                </Button>
              </Box>

              <Box>
                <Button
                  onClick={resetSearch}
                  variant="outlined"
                >
                  Reset
                </Button>
              </Box>
            </>
          )}

          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            <Button
              variant="contained"
              id="addtaskbutton"
              onClick={handleClickOpen}
            >
              Add Task
            </Button>
          </Box>
        </Box>
      </Box>

      <Dialog open={open} onClose={(event, reason) => { if (reason === "backdropClick" || reason === "escapeKeyDown") { return; } handleClose(event, reason); }} 
              maxWidth="md" fullWidth disableScrollLock={true} keepMounted={false} hideBackdrop={false} style={{ zIndex: 1300 }}>
        <DialogTitle
          className="btn-primary"
          sx={{
            height: "64px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 16px",
          }}
        >
          {editingTask ? "Edit Task" : "Add Task"}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
            <Box sx={{ width: "98%", mt: 2, mb: 1 }}>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  name="taskFormType"
                  value={taskFormType}
                  onChange={handleTaskFormTypeChange}
                >
                  <FormControlLabel
                    value="Customer"
                    control={<Radio />}
                    label="Customer"
                  />
                  <FormControlLabel
                    value="Policies"
                    control={<Radio />}
                    label="Policies"
                  />
                </RadioGroup>
              </FormControl>
            </Box>

            {taskFormType === "Policies" && (
              <Box sx={{ width: "21%" }}>
                <Typography variant="body1" sx={{ mb: 1, mt: 2 }}>
                  Select Policy <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  name="selectPolicyId"
                  fullWidth
                  select
                  SelectProps={{ native: true }}
                  value={selectPolicyId}
                  onChange={handlePolicyChange}
                  error={!!errors.selectPolicyId}
                  helperText={errors.selectPolicyId}
                >
                  <option style={{ fontSize: "13px" }} value="">
                    Select Policy
                  </option>
                  {policies.map((policy) => (
                    <option
                      style={{ fontSize: "13px" }}
                      key={policy.id}
                      value={Number(policy.id)}
                    >
                      {policy.policyNumber}
                    </option>
                  ))}
                </TextField>
              </Box>
            )}

            <Box sx={{ width: "21%" }}>
              <Typography variant="body1" sx={{ mb: 1, mt: 2 }}>
                Assigned To <span style={{ color: "red" }}>*</span>
              </Typography>
              <Autocomplete
                options={searchUsers}
                getOptionLabel={(option) => {
                  if (typeof option === "string") return option;

                  const fullName = `${option?.firstName || ""} ${option?.lastName || ""}`.trim();
                  return fullName || option?.firstName || "";
                }}
                value={searchUsers.find((user) => user.id === formValues.assignedTo) || null}
                onChange={(event, newValue) => {
                  const assignedId = newValue?.id || "";
                  const assignedName = newValue
                    ? `${newValue.firstName || ""} ${newValue.lastName || ""}`.trim()
                    : "";

                  setFormValues((prev) => ({
                    ...prev,
                    assignedToName: assignedName,
                    assignedTo: assignedId,
                  }));

                  setIsAssignedToSelected(!!assignedId);


                  if (assignedId) {
                    setErrors((prevErrors) => {
                      const newErrors = { ...prevErrors };
                      delete newErrors.assignedToName;
                      return newErrors;
                    });
                  }
                }}
                disabled={taskFormType === "Policies" ? !selectPolicyId : false}
                onInputChange={handleUserInputChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search users..."
                    error={!!errors.assignedToName}
                    helperText={errors.assignedToName}
                    fullWidth
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props}>
                    {typeof option === "string"
                      ? option
                      : `${option.firstName} ${option.lastName} (${option.email})`}
                  </li>
                )}
              />
            </Box>


            <Box sx={{ width: "26%" }}>
              <Typography variant="body1" sx={{ mb: 1, mt: 2 }}>
                Select Due Date <span style={{ color: "red" }}>*</span>
              </Typography>
              <DatePickerField
                fieldName="dueDate"
                formData={formData}
                handleDateChange={handleDateChange}
                handleBlur={(fieldName, errorMsg) => {
                  setTouchedFields((prev) => ({ ...prev, [fieldName]: true }));
                  setFieldErrors((prev) => ({ ...prev, [fieldName]: errorMsg }));
                }}
                touchedFields={touchedFields}
                fieldErrors={{
                  ...fieldErrors,
                  dueDate: errors.dueDate || fieldErrors.dueDate
                }}
              />
            </Box>


            <Box sx={{ width: "21%" }}>
              <Typography variant="body1" sx={{ mb: 1, mt: 2 }}>
                Select Status <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                placeholder="Select Status"
                name="status"
                id="selectstatus"
                fullWidth
                value={formValues.status || "Open"}
                onChange={(e) => {
                  const value = e.target.value;
                  setFormValues((prev) => ({
                    ...prev,
                    status: value,
                  }));


                  if (value) {
                    setErrors((prevErrors) => {
                      const newErrors = { ...prevErrors };
                      delete newErrors.status;
                      return newErrors;
                    });
                  }
                }}
                select
                SelectProps={{ native: true }}
                error={!!errors.status}
                helperText={errors.status}
                disabled={!allFieldsEnabled}
              >
                <option value="" disabled>
                  Select Status
                </option>
                <option value="Open">Open</option>
                {editingTask && <option value="Close">Close</option>}
              </TextField>
            </Box>


            <Box sx={{ width: "21%" }}>
              <Typography variant="body1" sx={{ mb: 1, mt: 2 }}>
                Task Priority <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                disabled={!allFieldsEnabled}
                placeholder="Task Priority"
                name="priority"
                id="TaskPriority"
                fullWidth
                value={formValues.priority}
                onChange={(e) => {
                  const value = e.target.value;
                  setFormValues((prev) => ({
                    ...prev,
                    priority: value,
                  }));


                  if (value) {
                    setErrors((prevErrors) => {
                      const newErrors = { ...prevErrors };
                      delete newErrors.priority;
                      return newErrors;
                    });
                  }
                }}
                error={!!errors.priority}
                helperText={errors.priority}
                select
                SelectProps={{ native: true }}
              >
                <option value="" disabled>
                  Select
                </option>
                <option value="URGENT">URGENT</option>
                <option value="HIGH">HIGH</option>
                <option value="MEDIUM">Medium</option>
                <option value="LOW">LOW</option>
              </TextField>
            </Box>


            <Box sx={{ width: "21%" }}>
              <Typography variant="body1" sx={{ mb: 1, mt: 2 }}>
                Type Of Task <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                disabled={!allFieldsEnabled}
                placeholder="Type Of Task"
                name="taskType"
                id="TypeOfTask"
                fullWidth
                value={formValues.taskType}
                onChange={(e) => {
                  const value = e.target.value;
                  setFormValues((prev) => ({
                    ...prev,
                    taskType: value,
                  }));

                  setErrors((prevErrors) => {
                    const newErrors = { ...prevErrors };
                    if (value) delete newErrors.taskType;
                    return newErrors;
                  });
                }}
                error={!!errors.taskType}
                helperText={errors.taskType}
                select
                SelectProps={{ native: true }}
              >
                <option value="" disabled>
                  Select
                </option>
                {typeOfTaskOpens.length > 0 ? (
                  typeOfTaskOpens.map((task, index) => (
                    <option key={index} value={task}>
                      {task}
                    </option>
                  ))
                ) : (
                  <option disabled>Loading...</option>
                )}
              </TextField>
            </Box>


            <Box sx={{ width: "98%", height: "40%" }}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Task Description <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                disabled={!allFieldsEnabled}
                name="taskDescription"
                id="task"
                fullWidth
                multiline
                rows={3}
                value={formValues.taskDescription}
                onChange={(e) => {
                  const value = e.target.value;
                  setFormValues((prev) => ({
                    ...prev,
                    taskDescription: value,
                  }));


                  if (value.trim()) {
                    setErrors((prevErrors) => {
                      const newErrors = { ...prevErrors };
                      delete newErrors.taskDescription;
                      return newErrors;
                    });
                  }
                }}
                error={!!errors.taskDescription}
                helperText={errors.taskDescription}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ width: "98%", mt: 2, mb: 1 }}>
          <Button 
            onClick={handleClose}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}            
            variant="outlined"
            disabled={tableSaveLoader}
          >
            {editingTask ? "Update" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          height:
            fieldErrors.fromDate || fieldErrors.toDate || fieldErrors.dueDate ? "10px" : "0px",
          transition: "height 0.3s ease",
        }}
      />

      <StyledTableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {!customerId && <TableCell className="styled-table-heading">Policy Number</TableCell>}
              <TableCell className="styled-table-heading">Date</TableCell>
              <TableCell className="styled-table-heading">Created By</TableCell>
              <TableCell className="styled-table-heading">Due On</TableCell>
              <TableCell className="styled-table-heading">Description</TableCell>
              <TableCell className="styled-table-heading">Closed</TableCell>
              <TableCell className="styled-table-heading">Closed By</TableCell>
              <TableCell className="styled-table-heading">Priority</TableCell>
              <TableCell className="styled-table-heading">Status</TableCell>
              <TableCell className="styled-table-heading">Assigned</TableCell>
              <TableCell className="styled-table-heading">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {finalData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={11} align="center">
                 <NoDataFound/>
                </TableCell>
              </TableRow>
            ) : (
              finalData.map((row) => (
                <TableRow key={row.id} className="styled-table-row">
                  {!customerId && <TableCell>{row.policyNumber}</TableCell>}
                  <CustomTableCell timestamp={row.createdBy?.timestamp} />
                  <TableCell>{row.createdBy?.name || '-'}</TableCell>
                  <TableCell>{row.dueDate ? dayjs(row.dueDate).format("MM-DD-YYYY") : "-"}</TableCell>
                  <TableCell>
                    <Tooltip
                      title={row.taskDescription || ""}
                      arrow
                      placement="top"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            backgroundColor: "white",
                            color: "black",
                            boxShadow: 1,
                            border: "1px solid #ccc",
                            fontSize: "14px",
                            fontFamily: '"Poppins", sans-serif',
                          },
                        },
                      }}
                    >
                      <span>{getShortDescription(row.taskDescription)}</span>
                    </Tooltip>
                  </TableCell>
                  <TableCell>{row.closedDate ? dayjs(row.closedDate).format("MM-DD-YYYY") : "-"}</TableCell>
                  <TableCell>{row.closedByName}</TableCell>
                  <TableCell>{row.priority}</TableCell>
                  <TableCell>{row.status}</TableCell>
                  <TableCell>{row.assignedToName}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleEditClick(row)} size="small">
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton onClick={() => handleDeleteClick(row.id)} size="small">
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>

        {taskData.totalElements > 0 && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", padding: "1rem" }}>
            <span style={{ marginRight: 8, fontSize: "14px" }}>Rows per page:</span>
            <Box>
              <select
                value={rowsPerPage}
                onChange={handleRowsPerPageChange}
                style={{ padding: "6px 12px", borderRadius: "4px", borderColor: "#ccc" }}
              >
                {[5, 10, 15, 25].map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </Box>

            <Pagination
              count={Math.ceil(taskData.totalElements / rowsPerPage)}
              page={page + 1}
              onChange={(event, value) => handlePageChange(event, value - 1)}
              showFirstButton
              showLastButton
            />
          </Box>
        )}
      </StyledTableContainer>

      <Dialog
        open={openDialog}
        onClose={(event, reason) => { if (reason === "backdropClick" || reason === "escapeKeyDown") { return; } handleCancelDelete(event, reason); }}
        aria-labelledby="delete-confirmation-dialog-title"
        aria-describedby="delete-confirmation-dialog-description"
        disableScrollLock={true}
        keepMounted={false}
        hideBackdrop={false}
        style={{ zIndex: 1300 }}

      >
        <DialogTitle
          className="btn-primary"
          sx={{
            height: "54px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 16px",
          }}
          id="delete-confirmation-dialog-title"
        >
          Delete Confirmation
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ marginTop: 5 }} id="delete-confirmation-dialog-description">
            Are you sure you want to delete this task? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} variant="outlined" color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TaskComponent;